import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { useAppSelector } from "../../redux/hooks";
import Loading from "../../components/core/blocks/Loading";
import { useCurrentUserProfile } from "../../modules/auth/api/useCurrentUserProfile";
import { settledAuth } from "../../modules/auth/routeGuards";

function AuthenticatedLayout() {
  const authLoading = useAppSelector((state) => state.auth.loading);
  const { isLoading: profileLoading } = useCurrentUserProfile();

  if (authLoading || profileLoading) {
    return <Loading height="100vh" />;
  }

  return <Outlet />;
}

/** Layout for every route that needs a signed-in user; anonymous visitors go to login and come back after. */
export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ context, location }) => {
    const { isAuthenticated } = await settledAuth(context.store);
    if (!isAuthenticated) {
      throw redirect({ to: "/", search: { redirect: location.href }, replace: true });
    }
  },
  pendingComponent: () => <Loading height="100vh" />,
  component: AuthenticatedLayout,
});
